export default "__VITE_ASSET__CLKWLDj3__"